import { ColorCardListT } from '@components/Organisms/ColorCardList/types';
import { FC } from 'react';
import { StyledColorCardList } from '@components/Organisms/ColorCardList/styled/StyledColorCardList';
import { ColorCard } from '@components/Organisms/ColorCardList/ColorCard';

export const ColorCardList: FC<ColorCardListT> = ({ title, display, colorCards, extraText }) => {
  if (!display) return null;

  return (
    <StyledColorCardList>
      <h2>{title}</h2>
      <div className="cards">
        {colorCards.map((colorCard, index) => (
          <ColorCard
            key={index}
            title={colorCard.title}
            description={colorCard.description}
            color={colorCard.color}
          />
        ))}
      </div>
      <p>{extraText}</p>
    </StyledColorCardList>
  );
};
